module.exports = require("./lib/_stream_writable.js")



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/node-libs-browser/~/readable-stream/writable.js
 ** module id = 295
 ** module chunks = 46 47
 **/